import React, { Component, Fragment } from "react"
import "react-confirm-alert/src/react-confirm-alert.css"
import Pagination from "react-js-pagination"

//components
import { ListHeader, SearchFilter, ListTable } from "../../components/ListPage"

//services
import {
  MeetingNotesServices,
  DevelopmentServices,
  StyleServices,
  SampleServices,
  SystemServices,
  CustomerServices,
  CostingServices,
  PermissionServices,
  EmployeeSampleServices,
  NewSampleRequestServices
} from "../../services"

//alert
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"

//options
import { tableHeader } from "../../services/common/options"
import Loading from "../../components/Common/Loading"

export default class List extends Component {
  state = {
    moduleName: "",
    type: "",
    isLoading: false,
    history: this.props.history,

    //PageHeaderForList
    header: "",
    link: "",
    toggleFilter: false,

    //SearchFilter
    byOption: [],
    byValue: "",
    inputSearch: "",

    //ListTable
    tableHeaderData: [],
    tableRowData: [],
    viewLink: "",
    editLink: "",

    costingCompare: [],

    //pagination
    activePage: 1,
    totalItemsCount: 0,

    //loading table
    isLoadingTable: false
  }

  componentWillMount() {
    const { moduleName, type } = this.props.location.state
    // console.log(moduleName, "safsdf324345345");
    
    this.setState({
      moduleName,
      type
    })
    this.setState({
      isLoadingTable: false
    })

    this.initializeValues(moduleName)

    if (this.props.location.search !== "") {
      const urlParams = new URLSearchParams(this.props.location.search)
      this.setState(
        {
          byValue: urlParams.get("byValue"),
          inputSearch: urlParams.get("inputSearch"),
          activePage: urlParams.get("activePage")
        },
        () => {
          if (this.state.inputSearch !== "") {
            this.searchFuncParams()
          } else {
            this._updateListData(moduleName)
          }
        }
      )
    } else {
      this._updateListData(moduleName)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { moduleName, type } = nextProps.location.state
    if (moduleName !== this.state.moduleName) {
      this.setState(
        {
          moduleName: moduleName,
          type: type,
          activePage: 1,
          history: nextProps.history,
          toggleFilter: false,
          inputSearch: ""
        },
        () => {
          this.initializeValues(moduleName)
          this.setState({ isLoadingTable: false }),
            this._updateListData(this.state.moduleName)
        }
      )
    }

    if (nextProps.location.search !== "") {

      const urlParams = new URLSearchParams(nextProps.location.search)
      const byValue = urlParams.get("byValue")
      const inputSearch = urlParams.get("inputSearch")
      const activePage = urlParams.get("activePage")

      if (inputSearch !== "") {
        this.setState(
          {
            byValue,
            inputSearch,
            activePage
          },
          () => this.searchFuncParams()
        )
      } else {
        this.setState(
          {
            activePage
          },
          () => this._updateListData(this.state.moduleName)
        )
      }
    }
  }

  initializeValues = moduleName => {
    switch (moduleName) {
      case "MEETINGROOM":
        this.setState({
          header: "Meeting Notes",
          addLink: "/MeetingNote",
          editLink: "/MeetingNote",
          viewLink: "/MeetingNote",
          byOption: [
            { label: "MN id ", value: "MNId" },
            { label: "Customer-Department", value: "custDept" }
            // { label: "Customer Name", value: "customerName" },
            // { label: "Department name", value: "customerDepartment" }
          ],
          byValue: "MNId"
        })
        break

      case "CUSTOMER":
        this.setState({
          header: "Customer",
          addLink: "/CustomerPage",
          editLink: "/CustomerPage",
          viewLink: "/CustomerPage",
          byOption: [
            { value: "customerName", label: "Customer Name" },
            { value: "customerCode", label: "Customer Code	" }
          ],
          byValue: "customerName"
        })
        break

      case "CAD":
        this.setState({
          header: "CAD",
          addLink: "/developmentCad",
          editLink: "/developmentCad",
          viewLink: "/developmentCad",
          byOption: [
            { label: "3D No ", value: "cadRefNumber" },
            { label: "Style No.", value: "styleNumber" },
            { label: "Customer-Department", value: "custDept" },
            { label: "3D Type", value: "cadType" },
            { label: "3D name", value: "cadName" },
            { label: "Category", value: "category" },
            { label: "Print Type", value: "printType" },
            { label: "Story Name", value: "storyName" }
          ]
        })
        break

      case "FABRIC":
        this.setState({
          header: "Fabric",
          addLink: "/developmentFabric",
          editLink: "/developmentFabric",
          viewLink: "/developmentFabric",
          byOption: [
            { value: "fabricNumber", label: "Fabric No" },
            { value: "devRefNumber", label: "Dev ref no" },
            { value: "countAndConstruction", label: "Count & Construction" },
            { value: "quality", label: "Quality" },
            { value: "classificationOfFabric", label: "Classification" },
            { value: "supplierName", label: "Supplier Name" }
          ],
          byValue: "fabricNumber"
        })
        break
      case "STYLE":
        this.setState({
          header: "style",
          addLink: "/StylePage",
          editLink: "/StylePage",
          viewLink: "/StylePage",
          byOption: [
            { value: "styleNo", label: "Style No / Ref" },
            { value: "styleName", label: "Style name" },
            { value: "custDept", label: "Customer-Department" },
            // { value: "customerName", label: "Customer Name" },
            // { value: "customerDepartment", label: "Department Name" },
            { value: "customerRefNumber", label: "Cust ref no" },
            { value: "itemNumber", label: "Item no" },
            { value: "fabricType", label: "Fabric type" },
            { value: "garmentType", label: "Garment type" }
          ],
          byValue: "styleNo"
        })
        break
      case "TRIM":
        this.setState({
          header: "Trim",
          addLink: "/Trim",
          editLink: "/Trim",
          viewLink: "/Trim",
          byOption: [
            { label: "Trim No", value: "trimNumber" },
            { label: "Category", value: "trimCategory" },
            { label: "Description", value: "description" },
            { label: "Supplier ref no", value: "supplierRef" },
            { label: "Supplier", value: "supplierName" }
          ],
          byValue: "trimNumber"
        })
        break
      case "SOURCING":
        this.setState({
          header: "SOURCING",
          addLink: "/developmentSourcing",
          editLink: "/developmentSourcing",
          viewLink: "/developmentSourcing",
          byOption: []
        })
        break
      case "SAMPLEREQUEST":
        this.setState({
          header: "SAMPLE REQUEST",
          addLink: "/Sample",
          editLink: "/Sample",
          viewLink: "/Sample",
          byOption: [
            { label: "Style No.", value: "magnumStyleNumber" },
            { label: "SampleRequest No", value: "requestNumber" },
            { label: "Style Name", value: "magnumStyleName" },
            { value: "custDept", label: "Customer-Department" },
            // { label: "Customer Name", value: "customerName" },
            // { label: "Customer Dept", value: "customerDept" },
            { label: "Cust Ref No", value: "customerId" },
            { label: "Source Of Request", value: "typeOfRequest" },
            { label: "Sample Type", value: "sampleType" }
          ],
          byValue: "magnumStyleNumber"
        })
        break
      case "BNUMBER":
        this.setState({
          header: "B NO",
          addLink: "/BNumber",
          editLink: "/BNumber",
          viewLink: "/BNumber",
          byOption: [
            { label: "B Number", value: "bNumber" },
            { label: "Fabric No.", value: "fabricNo" },
            { label: "Count&Construction", value: "countConstruction" },
            { label: "Quality", value: "quality" },
            { label: "Classification", value: "classification" },
            { label: "Greige Mill", value: "greigeMill" },
            { label: "Process Mill", value: "processMill" }
          ],
          byValue: "bNumber"
        })
        break
      case "SYSTEMSUPPLIER":
        this.setState({
          header: "System Supplier",
          addLink: "/system/Supplier",
          editLink: "/system/Supplier",
          viewLink: "/system/Supplier",
          byOption: []
        })
        break
      case "COSTING":
        this.setState({
          header: "Costing",
          addLink: "/CostingPage",
          editLink: "/CostingPage",
          viewLink: "/CostingPage",
          byOption: [
            { label: "Style No / Ref", value: "styleReferenceNo" },
            { label: "Costing Id", value: "costingNo" },
            { label: "Sample Request No", value: "sampleRequestNo" },
            { label: "Style Name", value: "styleName" },
            { value: "custDept", label: "Customer-Department" },
            { label: "Costing Type", value: "costingType" },
            // { label: "Customer", value: "customer" },
            // { label: "Department", value: "department" },
            // { label: "Sample Type", value: "sampleType" },            
            // { label: "Total Cost(₹​)", value: "totalCost" },
            // { label: "Total Cost(Currency)", value: "totalCost" }
          ],
          byValue: "styleReferenceNo"
        })
        break
      case "EMPLOYEE":
        this.setState({
          header: "Employee",
          addLink: "/employee",
          editLink: "/employee",
          viewLink: "/employee",
          byOption: [
            { label: "User ID", value: "userId" },
            { label: "Name", value: "employeeName" },
            { label: "Role ", value: "roleName" }
          ],
          byValue: "userId"
        })
        break
      case "ROLE":
        this.setState({
          header: "Role",
          addLink: "/permissionRole",
          editLink: "/permissionRole",
          viewLink: "/permissionRole",
          byOption: [{ label: "Role name", value: "roleName" }],
          byValue: "roleName"
        })
        break
      case "SMVTHREAD":
        this.setState({
          header: "Smv/Ob & Thread Consumption",
          addLink: "/SmvThread",
          editLink: "/SmvThread",
          viewLink: "/SmvThread",
          byOption: [
            { label: "Style No/Ref.", value: "styleNo" },
            { label: "SMV No.", value: "smvNo" },
            { label: "Style Name", value: "styleName" },
            { label: "Customer Name", value: "customerName" },
            { label: "Customer Dept.Name", value: "customerDepartment" }
          ],
          byValue: "styleNo"
        })
        break
      case "TECHNICALISSUES":
        this.setState({
          header: "Technical issues",
          addLink: "/technicalIssues",
          editLink: "/technicalIssues",
          viewLink: "/technicalIssues",
          byOption: [
            { label: "Style No/Ref.", value: "styleNo" },
            { label: "Issue No.", value: "issueNumber" },
            { label: "Style Name", value: "styleName" },
            { label: "Customer Name", value: "customerName" },
            { label: "Customer Dept.Name", value: "customerDepartment" }
          ],
          byValue: "styleNo"
        })
        break
      case "CREATEIB":
        this.setState({
          header: "Create IB",
          addLink: "/CreateIB",
          editLink: "/CreateIB",
          viewLink: "/CreateIB",
          byOption: [
            { label: "heading 1", value: "empty" },
            { label: "heading 2", value: "empty" },
            { label: "heading 3", value: "empty" },
            { label: "heading 4", value: "empty" }
          ]
        })
        break
        case "NEWSAMPLEREQUEST":
        this.setState({
          header: "New Sample Request",
          addLink: "/newsamplerequest",
          editLink: "/newsamplerequest",
          viewLink: "/newsamplerequest",
          byOption: [
            // { label: "User ID", value: "userId" },
            // { label: "Name", value: "name" },
            { label: "Request No", value: "requestNumber" }
          ],
          byValue: "newsamplerequest"
        })
        break
        case "NEWEMPLOYEE":
        this.setState({
          header: "New Employee",
          addLink: "/newemployee",
          editLink: "/newemployee",
          viewLink: "/newemployee",
          byOption: [
            // { label: "User ID", value: "userId" },
            { label: "Name", value: "name" },
            // { label: "Total Request", value: "totalRequests" }
          ],
          byValue: "newemployee"
        })
        break
      default:
    }
  }

  _updateListData = moduleName => {
    this.setState({
      isLoading: true
    })
    switch (moduleName) {
      case "MEETINGROOM":
        MeetingNotesServices.listMeetingNotes(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.meetingNoteTable,
                tableRowData: response.text.data.MN,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break

      case "CUSTOMER":
        CustomerServices.listCustomer(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.customerTable,
                tableRowData: response.text.data.custs,
                totalItemsCount: response.text.data.custumerCount,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break

      case "CAD":
        DevelopmentServices.listCAD(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.cadTable,
                tableRowData: response.text.data.cad,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status == 404 &&
              this.props.getalertMessage("error", response.text.message)
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("delete", JSON.stringify(error))
          })
        break

      case "FABRIC":
        DevelopmentServices.listFabric(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.fabricTable,
                tableRowData: response.text.data.fabArray,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })

        break
      case "STYLE":
        StyleServices.listStyles(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.styleTable,
                tableRowData: response.text.data.styleArray,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })

        break
      case "TRIM":
        DevelopmentServices.listTrim(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.trimTable,
                tableRowData: response.text.data.trimArray,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "SOURCING":
        DevelopmentServices.listSourcing(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.sourcingTable,
                tableRowData: response.text.data.sourcingArray,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })

        break
      case "SAMPLEREQUEST":
        SampleServices.listSamples(
          this.state.activePage,
          this.props.location.state.referenceId
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.samplerequestTable,
                tableRowData: response.text.data.SR,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "BNUMBER":
        DevelopmentServices.listBNumber(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.bnoTable,
                tableRowData: response.text.data.bNumbers,
                totalItemsCount: response.text.data.bNumbersCount,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "SYSTEMSUPPLIER":
        SystemServices.listSystemSuppliers(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              let tableRowData = [...response.text.data.data]
              tableRowData = tableRowData.map(data => {
                data.supplierStatus = data.supplierStatus
                  ? "active"
                  : "inactive"
                return data
              })
              this.setState({
                tableHeaderData: tableHeader.systemSupplierTable,
                tableRowData,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "FABRICREPORT":
        SystemServices.listSystemSuppliers(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              let tableRowData = [...response.text.data.data]
              tableRowData = tableRowData.map(data => {
                data.supplierStatus = data.supplierStatus
                  ? "active"
                  : "inactive"
                return data
              })
              this.setState({
                tableHeaderData: tableHeader.systemSupplierTable,
                tableRowData,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "COSTING":
        CostingServices.listCostings(
          this.state.activePage,
          this.props.location.state.sampleRequestId
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.costingTable,
                tableRowData: response.text.data.costingList,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error)
          })
        break
      case "EMPLOYEE":
        PermissionServices.listEmploye(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.employeeTable,
                tableRowData: response.text.data.users,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error)
          })
        break
      case "ROLE":
        PermissionServices.listRoles(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.roleTable,
                tableRowData: response.text.data.roleList,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error))
        break
      case "SMVTHREAD":
        StyleServices.listSMV(
          this.props.location.state.referenceId,
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.smvTable,
                tableRowData: response.text.data.smvList,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error))
        break
      case "TECHNICALISSUES":
        StyleServices.listTI(
          this.props.location.state.referenceId,
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.tiTable,
                tableRowData: response.text.data.techIssues,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error))
        break;
      case "CREATEIB":
        StyleServices.listIB(
          this.props.location.state.referenceId,
          this.state.activePage
        ).then(response => {
          if (response.status === 200) {
            this.setState({
              tableHeaderData: tableHeader.IBTable,
              tableRowData: response.text.data.ibData,
              totalItemsCount: response.text.data.count,
              isLoading: false,
              isLoadingTable: true
            })
          }
        })
        break;
        case "NEWSAMPLEREQUEST":
        NewSampleRequestServices.newsamplerequest(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.newsamplerequestTable,
                tableRowData: response.text.data,
                totalItemsCount: response.text.totalDocs,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error)
          })
        break
        case "NEWEMPLOYEE":
        EmployeeSampleServices.employees(this.state.activePage)
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.newemployeeTable,
                tableRowData: response.text.data,
                totalItemsCount: response.text.total,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error)
          })
        break
      default:
    }
  }

  _selectBy = value => {
    this.setState({
      byValue: value
    })
  }

  _inputChangeSearchQuery = e => {
    this.setState({
      inputSearch: e.target.value
    })
  }

  resetFunc = () => {
    this.setState(
      {
        byValue: this.state.byOption[0].value,
        inputSearch: "",
        activePage: 1
      },
      () =>
        this.props.history.push({
          pathname: "/list",
          search:
            "?" +
            new URLSearchParams({
              byValue: "",
              inputSearch: "",
              activePage: 1
            }).toString(),
          state: {
            moduleName: this.state.moduleName,
            type: this.state.type
          }
        })
    )
  }

  searchFunc = () => {
    if (this.state.inputSearch === "" || this.state.byValue === "") {
      this.props.getalertMessage("info", "Enter valid input in BY and FOR!")
    } else {
      this.props.history.push({
        pathname: "/list",
        search:
          "?" +
          new URLSearchParams({
            byValue: this.state.byValue,
            inputSearch: this.state.inputSearch,
            activePage: this.state.activePage
          }).toString(),
        state: {
          moduleName: this.state.moduleName,
          type: "list"
        }
      })
    }
  }

  searchFuncParams = () => {
    this.setState({ isLoadingTable: false, isLoading: true })
    switch (this.state.moduleName) {
      case "MEETINGROOM":
        MeetingNotesServices.searchMeetingNotesBy(
          this.state.byValue,
          this.state.inputSearch.trim()
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.meetingNoteTable,
                tableRowData:
                  response.text.data && response.text.data.MN
                    ? response.text.data.MN
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.count
                    : 0,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })

        break
      case "FABRIC":
        DevelopmentServices.searchFabricBy(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.fabricTable,
                tableRowData:
                  response.text.data && response.text.data.fabArray
                    ? response.text.data.fabArray
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.count
                    : 0,
                isLoadingTable: true,
                isLoading: false
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "BNUMBER":
        DevelopmentServices.searchBNumberDev(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.bnoTable,
                tableRowData:
                  response.text.data && response.text.data.bNumbers
                    ? response.text.data.bNumbers
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.bNumbersCount
                    : 0,
                isLoadingTable: true,
                isLoading: false
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "TRIM":
        DevelopmentServices.searchTrimBy(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.trimTable,
                tableRowData:
                  response.text.data && response.text.data.trimArray
                    ? response.text.data.trimArray
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.count
                    : 0,
                isLoadingTable: true,
                isLoading: false
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "ROLE":
        PermissionServices.searchRoles(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.roleTable,
                tableRowData:
                  response.text.data && response.text.data.roleList
                    ? response.text.data.roleList
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.count
                    : 0,
                isLoadingTable: true,
                isLoading: false
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
        break
      case "EMPLOYEE":
        PermissionServices.searchEmployeeList(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.employeeTable,
                tableRowData:
                  response.text.data && response.text.data.users
                    ? response.text.data.users
                    : [],
                totalItemsCount:
                  response.text.data && response.text.data.count
                    ? response.text.data.count
                    : 0,
                isLoadingTable: true,
                isLoading: false
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
        break
      case "CUSTOMER":
        this.setState({
          isLoading: true
        })
        CustomerServices.searchCustomersBy(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.customerTable,
                tableRowData: response.text.data.custs,
                totalItemsCount: response.text.data.custumerCount,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "STYLE":
        this.setState({
          isLoading: true
        })
        StyleServices.searchStylesBy(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.styleTable,
                tableRowData: response.text.data.styleArray,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "SMVTHREAD":
        this.setState({
          isLoading: true
        })
        StyleServices.searchSMVList(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.smvTable,
                tableRowData: response.text.data.smvList,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "TECHNICALISSUES":
        this.setState({
          isLoading: true
        })
        StyleServices.searchTIlist(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.tiTable,
                tableRowData: response.text.data.techIssues,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            } else {
              this.setState({ isLoading: false, isLoadingTable: true })
              // this.props.getalertMessage("error", response.text.message)
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "CAD":
        this.setState({
          isLoading: true
        })
        DevelopmentServices.searchCadList(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.cadTable,
                tableRowData: response.text.data.cad,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "COSTING":
        CostingServices.searchCosting(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.costingTable,
                tableRowData: response.text.data.costingList,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "SAMPLEREQUEST":
        this.setState({
          isLoading: true
        })
        SampleServices.searchSamplesBy(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.samplerequestTable,
                tableRowData: response.text.data.SR,
                totalItemsCount: response.text.data.count,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
        case "NEWSAMPLEREQUEST":
        this.setState({
          isLoading: true
        })
        NewSampleRequestServices.newsamplerequestsearch(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.newsamplerequestTable,
                tableRowData: response.text.data,
                totalItemsCount: response.text.totalDocs,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
        case "NEWEMPLOYEE":
        this.setState({
          isLoading: true
        })
        EmployeeSampleServices.newsampleemployeesearch(
          this.state.byValue,
          this.state.inputSearch.trim(),
          this.state.activePage
        )
          .then(response => {
            if (response.status === 200) {
              this.setState({
                tableHeaderData: tableHeader.newemployeeTable,
                tableRowData: response.text.data,
                totalItemsCount: response.text.total,
                isLoading: false,
                isLoadingTable: true
              })
            }
            response.status === 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      default:
    }
  }

  deleteFunc = id => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to delete this file?</p>
            <button type="button" class="primary" onClick={onClose}>
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              onClick={() => {
                this.setState({
                  isLoading: true
                })
                this._removeRow(id)
                onClose()
              }}
            >
              Yes, Delete it!
            </button>
          </div>
        )
      },
      closeOnClickOutside: true,
      // onClickOutside: () => {
      //   console.log("onClickOutside")
      // }
    })
  }

  _removeRow(id) {
    switch (this.state.moduleName) {
      case "MEETINGROOM":
        MeetingNotesServices.removeMeeting(id)
          .then(response => {
            if (response.status === 200) {
              if (response.text.message == "Meeting Note successfully deleted")
                this.props.getalertMessage("delete", response.text.message)
              else this.props.getalertMessage("info", response.text.message)

              MeetingNotesServices.listMeetingNotes(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.meetingNoteTable,
                      tableRowData: response.text.data.MN,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status == 404 &&
                    this.props.getalertMessage("error", response.text.message)

                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status == 401 && this.props.unauthorisedFunc()
            response.status == 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "CAD":
        DevelopmentServices.deleteCAD(id)
          .then(response => {
            if (response.status === 200) {
              if (response.text.message === "Successfully deleted") {
                this.props.getalertMessage("delete", response.text.message)
                DevelopmentServices.listCAD(this.state.activePage)
                  .then(response => {
                    if (response.status === 200) {
                      this.setState({
                        tableHeaderData: tableHeader.cadTable,
                        tableRowData: response.text.data.cad,
                        totalItemsCount: response.text.data.count,
                        isLoading: false,
                        isLoadingTable: true
                      })
                    }
                    response.status == 404 &&
                      this.props.getalertMessage("error", response.text.message)
                    response.status === 401 && this.props.unauthorisedFunc()
                  })
                  .catch(error => {
                    this.props.getalertMessage("error", JSON.stringify(error))
                  })
              }
            }
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "STYLE":
        StyleServices.removeStyle(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              StyleServices.listStyles(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.styleTable,
                      tableRowData: response.text.data.styleArray,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status == 404 &&
                    this.props.getalertMessage("error", response.text.message)
                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "BNUMBER":
        DevelopmentServices.removeBNumber(id)
          .then(response => {
            if (response.status == 200) {
              if (response.text.message === "Successfully Deleted") {
                this.props.getalertMessage("delete", response.text.message)
                DevelopmentServices.listBNumber(this.state.activePage)
                  .then(response => {
                    if (response.status === 200) {
                      this.setState({
                        tableHeaderData: tableHeader.bnoTable,
                        tableRowData: response.text.data.bNumbers,
                        totalItemsCount: response.text.data.bNumbersCount,
                        isLoading: false,
                        isLoadingTable: true
                      })
                    }
                    response.status === 401 && this.props.unauthorisedFunc()
                  })
                  .catch(error => {
                    this.props.getalertMessage("error", JSON.stringify(error))
                  })
              }
            }
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "SYSTEMSUPPLIER":
        SystemServices.removeSystemSupplier(id)
          .then(response => {
            if (response.status == 200) {
              if (response.text.message === "Successfully deleted") {
                this.props.getalertMessage("delete", response.text.message)

                SystemServices.listSystemSuppliers(this.state.activePage)
                  .then(response => {
                    if (response.status === 200) {
                      let tableRowData = [...response.text.data.data]
                      tableRowData = tableRowData.map(data => {
                        data.supplierStatus = data.supplierStatus
                          ? "active"
                          : "inactive"
                        return data
                      })
                      this.setState({
                        tableHeaderData: tableHeader.systemSupplierTable,
                        tableRowData,
                        totalItemsCount: response.text.data.count,
                        isLoading: false,
                        isLoadingTable: true
                      })
                    }
                    response.status == 404 &&
                      this.props.getalertMessage("error", response.text.message)
                    response.status === 401 && this.props.unauthorisedFunc()
                  })
                  .catch(error => {
                    this.props.getalertMessage("error", JSON.stringify(error))
                  })
              }
            }
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "FABRIC":
        DevelopmentServices.removeFabric(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.message)
              DevelopmentServices.listFabric(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.fabricTable,
                      tableRowData: response.text.data.fabArray,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status == 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "TRIM":
        DevelopmentServices.removeTrim(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.message)
              DevelopmentServices.listTrim(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.trimTable,
                      tableRowData: response.text.data.trimArray,
                      totalItemsCount: response.text.data.count,
                      isLoading: true,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "CUSTOMER":
        CustomerServices.removeCustomer(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.message)
              CustomerServices.listCustomer(this.state.activePage)
                .then(response => {
                  if (response.status == 200) {
                    if (
                      response.text.message === "List successfully displayed"
                    ) {
                      this.setState({
                        tableHeaderData: tableHeader.customerTable,
                        tableRowData: response.text.data.custs,
                        totalItemsCount: response.text.data.custumerCount,
                        isLoading: false,
                        isLoadingTable: true
                      })
                    }
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status === 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "SOURCING":
        DevelopmentServices.removeSourcing(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.message)
              DevelopmentServices.listSourcing(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.sourcingTable,
                      tableRowData: response.text.data.sourcingArray,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "SAMPLEREQUEST":
        SampleServices.removeSample(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.message)
              SampleServices.listSamples(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.samplerequestTable,
                      tableRowData: response.text.data.SR,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status === 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "COSTING":
        CostingServices.removeCosting(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              CostingServices.listCostings(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.costingTable,
                      tableRowData: response.text.data.costingList,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status === 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break

      case "EMPLOYEE":
        PermissionServices.removeEmploye(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              PermissionServices.listEmploye(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.employeeTable,
                      tableRowData: response.text.data.users,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status === 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            } else if (response.status === 401) {
              this.props.unauthorisedFunc()
            } else if (response.status === 404) {
              this.props.getalertMessage("error", response.text.message)
            } else {
              this.props.getalertMessage("error", response.text.message)
            }
            this.setState({
              isLoading: false
            })
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "ROLE":
        PermissionServices.removeRole(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              PermissionServices.listRoles(this.state.activePage)
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.roleTable,
                      tableRowData: response.text.data.roleList,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                  response.status === 404 &&
                    this.props.getalertMessage("error", response.text.message)
                })
                .catch(error => {
                  this.props.getalertMessage("error", JSON.stringify(error))
                })
            } else if (response.status === 401) {
              this.props.unauthorisedFunc()
            } else if (response.status === 404) {
              this.props.getalertMessage("error", response.text.message)
            } else {
              this.props.getalertMessage("error", response.text.message)
            }
            this.setState({
              isLoading: false
            })
          })
          .catch(error => {
            this.props.getalertMessage("error", JSON.stringify(error))
          })
        break
      case "SMVTHREAD":
        StyleServices.removeThread(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              StyleServices.listSMV(
                this.props.location.state.referenceId,
                this.state.activePage
              )
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.smvTable,
                      tableRowData: response.text.data.smvList,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => this.props.getalertMessage("error", error))
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      case "TECHNICALISSUES":
        StyleServices.removeTechIssue(id)
          .then(response => {
            if (response.status == 200) {
              this.props.getalertMessage("delete", response.text.message)
              StyleServices.listTI(
                this.props.location.state.referenceId,
                this.state.activePage
              )
                .then(response => {
                  if (response.status === 200) {
                    this.setState({
                      tableHeaderData: tableHeader.tiTable,
                      tableRowData: response.text.data.techIssues,
                      totalItemsCount: response.text.data.count,
                      isLoading: false,
                      isLoadingTable: true
                    })
                  }
                  response.status === 401 && this.props.unauthorisedFunc()
                })
                .catch(error => this.props.getalertMessage("error", error))
            }
            response.status === 401 && this.props.unauthorisedFunc()
            response.status === 404 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
        break
      default:
    }
  }

  _handlePageChange = pageNumber => {
    // this._updateListData(this.state.moduleName)
    this.props.history.push({
      pathname: "/list",
      search:
        "?" +
        new URLSearchParams({
          byValue: this.state.byValue,
          inputSearch: this.state.inputSearch,
          activePage: pageNumber
        }).toString(),
      state: {
        moduleName: this.state.moduleName,
        type: "list"
      }
    })
  }

  toggleShowFilter = () => {
    this.setState(
      {
        toggleFilter: !this.state.toggleFilter
      },
      () => {
        if (!this.state.toggleFilter) {
          this.setState(
            {
              byValue: "",
              inputSearch: ""
            },
            () => this._updateListData(this.state.moduleName)
          )
        }
      }
    )
  }

  costingCompare = (data) => {
    if (data) {
      let costingCompare = [...this.state.costingCompare]
      let number = { _id: data._id, costingNumber: data.costingNumber }
      if (costingCompare) {
        let findNo = costingCompare.find(x => x._id === data._id)
        if (!findNo) {
          if (costingCompare.length >= 5) {
            costingCompare.splice(0, 1)
            costingCompare = [...costingCompare, number]
            this.setState({ costingCompare })
          } else {
            costingCompare = [...costingCompare, number]
            this.setState({ costingCompare })
          }
        }
      }
    }
  }

  clearCompare = () => {
    this.setState({ costingCompare: [] })
  }

  render() {
    const { isLoadingTable } = this.state
    if (this.state.isLoadingTable) {
      return (
        <Fragment>
          {this.state.isLoading && <Loading />}
          <div class="right-section bg-white remove-scroll-for-right">
            <div class="row nopadding ">
              <ListHeader
                costingCompare={this.state.costingCompare}
                clearCompare={this.clearCompare}
                header={this.state.header}
                link={this.state.addLink}
                type={this.state.type}
                toggleFilter={this.state.toggleFilter}
                history={this.state.history}
                onToggleShow={this.toggleShowFilter}
                getalertMessage={this.props.getalertMessage}
              />

              {/* {toggleFilter && ( */}
              <SearchFilter
                byOption={this.state.byOption}
                _selectBy={this._selectBy}
                filterSelect={this.state.byValue}
                inputSearch={this.state.inputSearch}
                _inputChangeSearchQuery={this._inputChangeSearchQuery}
                searchFunc={this.searchFunc}
                resetFunc={this.resetFunc}
              />
              {/* )} */}
              {isLoadingTable && (
                <ListTable
                  tableHeaderData={this.state.tableHeaderData}
                  tableRowData={this.state.tableRowData}
                  editLink={this.state.editLink}
                  viewLink={this.state.viewLink}
                  costingCompare={this.costingCompare}
                  moduleName={this.state.moduleName}
                  deleteFunc={this.deleteFunc}
                  history={this.props.history}
                />
              )}
              <div class="col-md-12 pull-right">
                {this.state.totalItemsCount > 0 && (
                  <Pagination
                    activePage={Number(this.state.activePage)}
                    itemsCountPerPage={100}
                    totalItemsCount={this.state.totalItemsCount}
                    pageRangeDisplayed={5}
                    onChange={this._handlePageChange}
                  />
                )}
              </div>
            </div>
          </div>
        </Fragment>
      )
    } else {
      return <Loading />
    }
  }
}

List.propTypes = {}

List.defaultProps = {}


// WEBPACK FOOTER //
// ./src/pages/list/page.js